import { render, staticRenderFns } from "./kaydetbutonu.vue?vue&type=template&id=396295fe&"
import script from "./kaydetbutonu.vue?vue&type=script&lang=js&"
export * from "./kaydetbutonu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports